import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1666 17.5V15.8333C14.1666 14.9493 13.8155 14.1014 13.1903 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16665C3.28259 12.5 2.43474 12.8512 1.80962 13.4763C1.1845 14.1014 0.833313 14.9493 0.833313 15.8333V17.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: "#585b5f"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.50002 9.16667C9.34097 9.16667 10.8334 7.67428 10.8334 5.83333C10.8334 3.99238 9.34097 2.5 7.50002 2.5C5.65907 2.5 4.16669 3.99238 4.16669 5.83333C4.16669 7.67428 5.65907 9.16667 7.50002 9.16667Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: "#585b5f"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1667 17.5001V15.8334C19.1661 15.0948 18.9203 14.3774 18.4678 13.7937C18.0153 13.2099 17.3818 12.793 16.6667 12.6084",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: "#585b5f"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3333 2.6084C14.0503 2.79198 14.6858 3.20898 15.1397 3.79366C15.5935 4.37833 15.8398 5.09742 15.8398 5.83757C15.8398 6.57771 15.5935 7.2968 15.1397 7.88147C14.6858 8.46615 14.0503 8.88315 13.3333 9.06673",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: "#585b5f"
		})
	]
});
export default SvgUsers;
